module.exports = __webpack_public_path__ + "static/media/afternoon.58e13df7.jpg";